"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CBAView = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var antd_1 = require("antd");
var collectionsRef_1 = require("common/db/collectionsRef");
var getRFQsByIds_1 = require("common/getters/getRFQsByIds");
var lodash_1 = require("lodash");
var index_modules_css_1 = __importDefault(require("portal/index.modules.css"));
var hasProjectPermission_1 = require("portal/pages/Projects/hasProjectPermission");
var react_1 = __importStar(require("react"));
var firestore_1 = require("react-firebase-hooks/firestore");
var react_i18next_1 = require("react-i18next");
var use_react_router_1 = __importDefault(require("use-react-router"));
var Draft_1 = __importDefault(require("../../Discussion/Draft"));
var useReducer_1 = __importDefault(require("../utils/useReducer"));
var CBAGrid_1 = require("./CBAGrid");
var CBAReducer_1 = require("./CBAReducer");
var moment_1 = __importDefault(require("moment"));
var CBAView = function () {
    var _a, _b, _c, _d, _e;
    var t = (0, react_i18next_1.useTranslation)().t;
    var params = useParams();
    var CBAId = match.params.CBAId;
    var _f = (0, firestore_1.useDocument)(collectionsRef_1.CBAsRef.doc(CBAId)), CBASN = _f[0], CBALoading = _f[1];
    var _g = (0, firestore_1.useCollection)(collectionsRef_1.CBAItemsRef.where("CBAId", "==", CBAId)), CBAItemsSN = _g[0], CBAItemsLoading = _g[1];
    var _h = (0, firestore_1.useCollection)(collectionsRef_1.CBARFQItemsRef.where("CBAId", "==", CBAId)), CBARFQItemsSN = _h[0], CBARFQItemsLoading = _h[1];
    var _j = (0, firestore_1.useCollection)(collectionsRef_1.suppliersRef), suppliersSn = _j[0], suppliersLoading = _j[1];
    var CBAData = ((_a = CBASN === null || CBASN === void 0 ? void 0 : CBASN.data()) !== null && _a !== void 0 ? _a : {});
    var _k = (0, firestore_1.useDocument)(collectionsRef_1.IRsRef.doc((_b = CBAData === null || CBAData === void 0 ? void 0 : CBAData.IRId) !== null && _b !== void 0 ? _b : "id")), IRSnapshot = _k[0], IRloading = _k[1];
    var IRData = ((_c = IRSnapshot === null || IRSnapshot === void 0 ? void 0 : IRSnapshot.data()) !== null && _c !== void 0 ? _c : {});
    var CBAItemsData = ((_d = CBAItemsSN === null || CBAItemsSN === void 0 ? void 0 : CBAItemsSN.docs) !== null && _d !== void 0 ? _d : []).map(function (doc) {
        return __assign(__assign({}, doc.data()), { id: doc.id });
    });
    var CBARFQItemsData = ((_e = CBARFQItemsSN === null || CBARFQItemsSN === void 0 ? void 0 : CBARFQItemsSN.docs) !== null && _e !== void 0 ? _e : []).map(function (doc) {
        return __assign(__assign({}, doc.data()), { id: doc.id });
    });
    var router = (0, use_react_router_1.default)();
    var _l = (0, useReducer_1.default)((0, CBAReducer_1.getCBAReducer)(router, t), null), state = _l[0], dispatch = _l[1];
    var _m = (0, firestore_1.useCollection)(collectionsRef_1.approvalsRef.where("formId", "==", CBAId)), approvalsSN = _m[0], approvalsLoading = _m[1];
    (0, react_1.useEffect)(function () {
        var _a;
        if (CBALoading ||
            CBAItemsLoading ||
            state ||
            !CBAData ||
            CBARFQItemsLoading ||
            CBALoading ||
            suppliersLoading ||
            !suppliersSn ||
            IRloading) {
            return;
        }
        (0, getRFQsByIds_1.getRFQsByIds)((_a = CBAData.RFQsIds) !== null && _a !== void 0 ? _a : []).then(function (RFQdata) {
            var _a, _b;
            var data = __assign(__assign({ IRData: IRData, RFQsData: RFQdata }, CBAData), { CBAId: CBAId, CBAItems: CBAItemsData, CBARFQItems: (0, lodash_1.zipObject)(CBARFQItemsData.map(function (d) { return d.id; }), CBARFQItemsData), approvalsData: (_a = approvalsSN === null || approvalsSN === void 0 ? void 0 : approvalsSN.docs.map(function (e) {
                    return __assign({}, e.data());
                })) !== null && _a !== void 0 ? _a : [], suppliersData: (_b = suppliersSn === null || suppliersSn === void 0 ? void 0 : suppliersSn.docs.map(function (x) {
                    return __assign(__assign({}, x.data()), { id: x.id });
                })) !== null && _b !== void 0 ? _b : [], approvedAtSignatureDate: (0, moment_1.default)() });
            dispatch({ type: "init", payload: data });
        });
    }, [
        IRData,
        CBAData,
        CBAItemsData,
        CBALoading,
        CBAItemsLoading,
        CBAId,
        state,
        CBARFQItemsLoading,
        CBARFQItemsData,
        approvalsSN,
        suppliersLoading,
        suppliersSn,
    ]);
    (0, react_1.useEffect)(function () {
        var _a;
        if (!approvalsSN || !state) {
            return;
        }
        dispatch({
            type: "update",
            payload: {
                path: "approvalsData",
                newValue: (_a = approvalsSN === null || approvalsSN === void 0 ? void 0 : approvalsSN.docs.map(function (e) {
                    return __assign({}, e.data());
                })) !== null && _a !== void 0 ? _a : [],
            },
        });
        // eslint-disable-next-line  react-hooks/exhaustive-deps
    }, [approvalsSN]);
    if (CBALoading || CBAItemsLoading || !state || approvalsLoading) {
        return (0, jsx_runtime_1.jsx)(antd_1.Spin, { size: "large" });
    }
    var mode = state.status === "draft" ? "edit" : "view";
    var projectId = state === null || state === void 0 ? void 0 : state.projectId;
    var CBAViewDiscussionPermission = (0, hasProjectPermission_1.hasProjectPermission)(projectId, [
        "CBAViewDiscussion",
    ]);
    var CBAParticipateInDiscussionPermission = (0, hasProjectPermission_1.hasProjectPermission)(projectId, [
        "CBAParticipateInDiscussion",
    ]);
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: index_modules_css_1.default.orderContainer }, { children: [(0, jsx_runtime_1.jsx)(CBAGrid_1.CBAGrid, { state: state, mode: mode, dispatch: dispatch, CBAId: CBAId }), CBAViewDiscussionPermission ? ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "".concat(index_modules_css_1.default.orderSection, " ").concat(index_modules_css_1.default.orderFooter) }, { children: [(0, jsx_runtime_1.jsx)("h2", { children: t("common.discussion") }), (0, jsx_runtime_1.jsx)(Draft_1.default, { kind: "comparative-bid-analyse", docId: CBAId, viewInput: CBAParticipateInDiscussionPermission })] }))) : null] })));
};
exports.CBAView = CBAView;
exports.default = exports.CBAView;
